import React, { useState, useEffect } from "react";

import { useAPI } from "services/Api";
import Input from "input/Input";
import Page from "pages/Page";
import { navigate } from "utility/NavigationService";
import { useNotificationManager } from "notifications/NotificationManager";

const EditUser = ({ componentName = "[EditUser]" }) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");

    const API = useAPI();
    const notificationManager = useNotificationManager();

    useEffect(
        () => {
            void getData();
        }, []
    );

    const getData = async () => {
        await API.api_Get(
            componentName,
            `/user/`,
            notificationManager,
            (response) => {
                setFirstName(response.data.first_name);
                setLastName(response.data.last_name);
                setEmail(response.data.email);
            },
            (error) => {
                console.error(error)
                notificationManager.addError(error);
            }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        updateData(JSON.stringify({ first_name: firstName, last_name: lastName }));
    };

    const updateData = async (data) => {
        await API.api_Post(
            componentName,
            `/user/`,
            data,
            notificationManager,
            (_response) => {
                goToUser();
            },
            (error) => {
                console.error(error.response);
                notificationManager.addError(error);
            }
        );
    };

    const goToUser = () => {
        void navigate(`/user/`);
    };

    return (
        <Page
            componentName={componentName}
        >
            <form onSubmit={handleSubmit}>
                <Input
                    name="First name"
                    required
                    type="text"
                    value={firstName ? firstName : ""}
                    // Callbacks
                    onChange={setFirstName}
                />
                <Input
                    name="Last name"
                    required
                    type="text"
                    value={lastName ? lastName : ""}
                    // Callbacks
                    onChange={setLastName}
                />
                <Input
                    name="Email (optional)"
                    type="text"
                    validations={[{ type: "email", value: email }]}
                    value={email ? email : ""}
                    // Callbacks
                    onChange={setEmail}
                />
                <button className="cursor-pointer">Save</button>
            </form>
        </Page>
    );
};

export default EditUser;
